import angular from 'angular';

import component from './attributes-presentation.component';

const AttributesPresentation = angular
    .module('control-room.commons.content.components.attributes-presentation', [])
    .component('crAttributesPresentation', component);

export default AttributesPresentation;
